import { getScribeHttpClients } from '@heidi/api/client';

import {
  type CreditAllowanceResponse,
  type WorkspaceCreditAllowancesResponse,
} from '../../contracts';
import { type CommerceHttpClient } from '../config';

const http = (): CommerceHttpClient => getScribeHttpClients().scribeHttpV2;

/** @domain commerce — GET /api/v2/ml-scribe/credit-allowance. */
export const getCreditAllowance = () => {
  return http().get<CreditAllowanceResponse>('/credit-allowance');
};

/** The backend caps `page_size` at 100. */
export const WORKSPACE_MEMBER_CREDIT_ALLOWANCES_PAGE_SIZE = 100;

/**
 * @domain commerce — GET /api/v2/ml-scribe/credit-allowance/workspaces/{workspace_id}/members.
 * Workspace admins only; 403 otherwise.
 */
export const getWorkspaceMemberCreditAllowances = (
  workspaceId: string,
  { page = 1, pageSize = WORKSPACE_MEMBER_CREDIT_ALLOWANCES_PAGE_SIZE } = {}
) => {
  return http().get<WorkspaceCreditAllowancesResponse>(
    `/credit-allowance/workspaces/${encodeURIComponent(workspaceId)}/members`,
    { params: { page, page_size: pageSize } }
  );
};
